module.exports = __webpack_public_path__ + "static/media/shuttleHygieneIcon.e9339b4d.png";